module.exports = __webpack_public_path__ + "img/jenkins.19b8fe0a.png";